module.exports = __webpack_public_path__ + "static/media/belt-replacement-red.3c48c7bf.svg";